/* eslint-disable @typescript-eslint/no-unused-vars */
import { Handle, Position } from '@xyflow/react'
import plcLogo from '@/assets/power.png'

const handleStyleLeft = { left: -2, top: 44 }

function PowerRegulatorNode({ data, isConnectable }) {
  return (
    <div className="custom-node-plc plc-limits">
      <Handle type="target" position={Position.Left} style={handleStyleLeft} />

      <div className="grid grid-cols-1">
        <div>
          <div></div>
          <div className="text-center">
            <img src={plcLogo} alt="Power Regulator Logo" className="custom-node-plc-logo" />
          </div>
          <div className="text-center">
            <b>Power Regulator</b>
          </div>
        </div>
      </div>

      <Handle type="source" position={Position.Right} />
      <Handle type="target" id="right" position={Position.Right} />
    </div>
  )
}

export default PowerRegulatorNode
